import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";

export const List = ({ items, testid }) => (
  <ul data-testid={testid} className="mt-4 space-y-2.5">
    {items.map((t) => (
      <li key={t} className="flex gap-3 text-sm sm:text-base text-ink-600 leading-relaxed">
        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />{t}
      </li>
    ))}
  </ul>
);

export const Section = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-serif text-3xl font-semibold text-forest-900">{title}</h2>
    {children}
  </section>
);

export const PenaltyTable = ({ rows, a, b, testid }) => (
  <div data-testid={testid} className="mt-5 rounded-2xl border border-parchment-200 bg-white divide-y divide-parchment-100">
    {rows.map((r) => (
      <div key={r[a]} className="p-4 sm:flex sm:gap-6">
        <p className="sm:w-1/3 font-semibold text-forest-900">{r[a]}</p>
        <p className="sm:flex-1 text-sm text-ink-600 mt-1 sm:mt-0">{r[b]}</p>
      </div>
    ))}
  </div>
);

export const Crumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1 text-xs text-ink-500">
    {items.map((it, i) => (
      <span key={it.name} className="flex items-center gap-1">
        {i > 0 && <ChevronRight className="h-3 w-3" />}
        {it.path ? <Link to={it.path} className="hover:text-terracotta">{it.name}</Link> : <span className="text-ink-700">{it.name}</span>}
      </span>
    ))}
  </nav>
);

export const ReviewNotice = ({ place }) => (
  <div data-testid="charge-review-notice" className="mt-8 flex gap-3 rounded-2xl border border-terracotta-border bg-terracotta-subtle p-4 text-sm text-ink-700">
    <AlertTriangle className="h-5 w-5 shrink-0 text-terracotta" />
    <p>Penalty details are AI-drafted summaries pending attorney review. Laws change and vary by county — always confirm
      with a licensed defense lawyer{place ? ` in ${place}` : ""} before making any decision. Not legal advice.</p>
  </div>
);
